import updateEmailForm from "./updateEmailForm";
export default updateEmailForm;
